import { useEffect, useContext, useState } from 'react';
import PostCard from 'src/components/posts/postCard/PostCard';
import CreateComment from 'src/components/posts/createComment/CreateComment';
import ViewComment from 'src/components/posts/viewComment/ViewComment';
import { Card, TDropdownOptions, Separator, Loader, Typography, ConfirmModal } from 'src/components/common';
import { TGetCommentsRequest, TPost } from 'src/services/apiEndpoint.types.ts';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import Collapse from 'react-bootstrap/Collapse';
import {
  clearComments,
  getComments,
  incrementCommentsPage,
  updateShowCommentsId
} from 'src/store/socialMedia/socialMedia.slice';
import { TUserTypes } from 'src/constants/user.constants';
import { SearchResultsContext } from 'src/pages/search/Search';

import './viewPost.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { NumberFormat } from 'xlsx';

export type TViewPost = {
  dropdownOptions: TDropdownOptions[];
  expandPost: boolean;
  post: TPost;
  viewerId: string;
  viewerType: TUserTypes;
  handleFollowFromSearchResult?: () => void;
  redirectToViewPost?: ({
    postId,
    ownerId,
    post
  }: {
    postId: string;
    ownerId: string;
    post: TPost;
  }) => void;
};

// This component must know id and type of the viewer
const ViewPost = ({
  dropdownOptions,
  post,
  viewerId,
  viewerType,
  expandPost,
  handleFollowFromSearchResult,
  redirectToViewPost
}: TViewPost) => {
  // Hooks
  const navigate = useNavigate()
  const location = useLocation()

  const {
    commentsPageNumber,
    commentsPerPage,
    comments,
    showCommentsId,
    commentsLoading,
    MoreCommentsLeft
  } = useAppSelector((store:any) => store.socialMedia);
  const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);
  const isSearchResultContext = useContext(SearchResultsContext); // Whether rendered from search module

  const [show, setShow] = useState<boolean>(false)
  const [page, setPage] = useState<number>(1)
  const postId = post?.post?.id;
  const url = `${location.pathname}${location.search}`
  const showComments = postId === showCommentsId;

  const dispatch = useAppDispatch();

  const handleGetComments = (number = 0) => {
    const payload: TGetCommentsRequest = {
      userId: viewerId,
      userType: viewerType,
      pageNumber: number || commentsPageNumber,
      commentsPerPage,
      postId,
      prevPage: number | page
    };
    setPage(commentsPageNumber)
    dispatch(getComments(payload));
  };

  const onCommentClick = () => {
    setPage(1)
    if (!isAuthorized) {
      setShow(true)
      return
    }
    if (isSearchResultContext && redirectToViewPost) {
      redirectToViewPost({ postId, ownerId: post?.user?.id, post });
    } else {
      if (!showCommentsId || showCommentsId !== postId) {
        dispatch(updateShowCommentsId(postId));
      } else {
        dispatch(updateShowCommentsId(''));
      }
    }
  };

  const handleCloseCreateComment = () => {
    dispatch(clearComments());
  };

  const handleFetchMoreComments = () => {
    // if (location.pathname === '/dashboard') {
    //   navigate(`/view-post?postId=${postId}`)
    // } else {
    //   dispatch(incrementCommentsPage(1));
    // }
    dispatch(incrementCommentsPage(1));
  };
  function handleNavigate() {
    navigate(`/login?prev=${url}`)
  }

  useEffect(() => {
    if (showComments && expandPost) {
      handleGetComments();
    }
  }, [showComments, commentsPageNumber, expandPost]);

  return (
    <>
      <Card className="view-post">
        {/*
       ** Post card
       */}
        <PostCard
          dropdownItems={dropdownOptions}
          onCommentClick={onCommentClick}
          highlightComment={showComments}
          post={post}
          viewerId={viewerId}
          viewerType={viewerType}
          handleFollowFromSearchResult={handleFollowFromSearchResult}
        />
        {/*
       ** Comments
       */}
        <Collapse in={showComments}>
          <div id={postId} className='view-post__comment-reply-box'>
            {expandPost && (
              <>
                <CreateComment
                  onClose={handleCloseCreateComment}
                  post={post}
                  handleGetComments={handleGetComments}
                  viewerId={viewerId}
                  viewerType={viewerType}
                />
              </>
            )}

            {expandPost && (
              <>
                {comments?.length > 0 && (
                  <>
                    <Separator />
                    <div className="view-post__comments">
                      {comments.map((item, index) => {
                        return (
                          <ViewComment
                            key={item?.comments?.id}
                            comment={item}
                            postId={postId}
                            handleGetComments={handleGetComments}
                            viewerId={viewerId}
                            viewerType={viewerType}
                          />
                        );
                      })}
                    </div>
                  </>
                )}
                {MoreCommentsLeft && !commentsLoading && (
                  <Typography
                    as="p"
                    variant="caption"
                    fontWeight="semiBold"
                    className="view-post__load-more-comments"
                    onClick={handleFetchMoreComments}
                  >
                    Show more comments
                  </Typography>
                )}
              </>
            )}
            {commentsLoading && showComments && <Loader />}
          </div>
        </Collapse>
      </Card>
      <ConfirmModal
        title=""
        description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
          <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
          <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
        </p>}
        openConfirmModal={show}
        onClose={() => setShow(false)}
        onSubmit={handleNavigate}
        submitText="Sign in"
        type="confirm"
      />
    </>
  );
};

export default ViewPost;
